import { defineStore } from 'pinia'

export interface Notification {
  type: 'Success' | 'Warning' | 'Error'
  title: string
  message: string
  icon: string
  timeout?: number
}

export const useNotificationStore = defineStore({
  // unique id of the store across your application
  id: 'notification',
  state: () =>
    ({
      notification: undefined,
    }) as { notification?: Notification },
  getters: {},
  actions: {
    clearNotification() {
      this.notification = undefined
    },
    setNotification(
      title: string,
      message: string,
      type: 'Success' | 'Warning' | 'Error' = 'Success',
      icon?: string,
      timeout?: number,
    ) {
      if (!icon) {
        switch (type) {
          case 'Success':
            icon = 'CheckCircleIcon'
            break
          case 'Warning':
            icon = 'InformationCircleIcon'
            break
          case 'Error':
            icon = 'ExclamationIcon'
            break
        }
      }
      this.notification = { title, message, type, icon, timeout }
    },
  },
})
